export default () => `
<div tabindex="-1" class="Autocompletions">
    <div class="Autocompletions-list js-autocompletionsList" role="listbox"></div>
</div>
`;
